<template>
  <layout :session="session" :participant="participant" :show-reset="false">

    <div class="mt-12 sm:mt-0 px-4 py-5 flex flex-col items-center justify-center w-full">
      <div class="flex-1 h-full max-w-sm mx-auto  select-none ">
        <img src="/img/participate.png" class="w-3/5 sm:w-4/5 mt-6 mb-12" />


        <session-logo :session="session"></session-logo>

        <div class="text-left mt-6 mx-auto max-w-lg">

          <p v-if="session.introtext" class="font-extralight whitespace-pre-line" v-html="session.introtext"></p>

          <div v-if="session.show_qr_code">
            <p class="mt-5 font-extralight">Teilen Sie diesen Code gerne auch mit anderen.</p>

            <div class="border-b border-gray-400 mt-8"></div>

            <div v-html="session.anonymous_access_link_qrcode" class="mt-12 w-3/5 sm:w-64 mx-auto"></div>
          </div>

          <p v-if="session.introText" class="font-extralight mt-12 text-sm" v-html="session.introText"></p>
        </div>


        <div class="flex w-full items-end justify-end mt-12">
          <a :href="route('anonymous-access.direct-access', {
            uuid: session.uuid,
          })
            "
            class="flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-brandpreneurship-dark-gray focus:outline-none focus:border-black focus:shadow-outline-red active:bg-black transition duration-150 ease-in-out w-full">START</a>
        </div>
      </div>



    </div>

    <!-- <template v-slot:footer>
      <a
      :href="
          route('anonymous-access.direct-access', {
            uuid: session.uuid,
          })
        "
        class="inline-flex justify-center w-full sm:w-min rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 bg-brandpreneurship-dark-gray text-base leading-6 font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50"
        >WEITER</a>
    </template> -->



    <div v-if="false" class="mt-20 items-center max-w-xl mx-auto px-12 py-5 text-left">

      <div class="border-t border-gray-400 mb-6"></div>

      <h1 class="text-[2.8rem] leading-[2.8rem] sm:text-5xl uppercase font-medium">
        Danke<br />fürs<br />Mitmachen.111
      </h1>

      <div class="border-t border-gray-400 mt-16"></div>
    </div>
  </layout>
</template>


<script>
import Layout from '@/Pages/DiyWorkshop/Shared/BlankLayout';
import SessionLogo from '@/Pages/DiyWorkshop/Shared/SessionLogo';

export default {
  components: {
    Layout,
    SessionLogo,
  },

  props: ['session', 'participant', 'translations'],

  created() {
    // Echo.channel('markencode-app.session.' + this.participant.markencode_session.id).here((users) => {
    //     console.log(users);
    // })
  },


  data() {
    return {
      sending: false
    };
  },

  methods: {}
};
</script>
